import Http from 'axios'
import router from '@/router'
import config from '@/config'
import storage from '@/plugins/storage'
import store from '@/store'
import { REQUEST_LOG_IN_AGAIN, SERVER_ERROR } from '@/constant/errorCode'
const http = Http.create()
const TOKEN_HEADER_NAME = 'school_token'
const DEVICE_TYPE = 'devicetype'
const pathDataRE = /{(\w+)}/ig

/**
 * 请求头处理
 */
http.interceptors.request.use(req => {
  const token = storage.get('token')
  if (token) {
    req.headers[TOKEN_HEADER_NAME] = token
  }
  req.headers[DEVICE_TYPE] = config.devicetype
  return req
})

/**
 * 响应结果处理
 */
http.interceptors.response.use(
  res => {
    const { data, succeed, isSuccess, resultMsg, resultCode } = res.data
    // 统一异常错误处理
    if (succeed === false || isSuccess === false) {
      const err = { code: resultCode, msg: resultMsg }
      if (resultCode === REQUEST_LOG_IN_AGAIN.code) {
        // 清空存储的token信息
        store.dispatch('app/quit')
        router.app.$Message.error(REQUEST_LOG_IN_AGAIN.msg)
        router.push({ name: 'Login' })
      } else {
        router.app.$Message.error(resultMsg)
      }
      return Promise.reject(err)
    } else {
      return data
    }
  },
  err => {
    const { status, data } = err.response
    if (status >= SERVER_ERROR.code) {
      router.app.$Message.error(SERVER_ERROR.msg)
    }
    return Promise.reject(data)
  }
)

/**
 * 请求数据封装
 * @param {*} method 方法
 * @param {*} url 请求地址
 */
function httpAgent (method, url) {
  return (data, config) => {
    method = method.toLowerCase()
    if (typeof config !== 'object' || config === null) {
      config = {}
    }
    // 替换path-variable，例如：/{id}
    let replacedUrl = ''
    if (pathDataRE.test(url)) {
      const paths = config.paths
      if (paths) {
        replacedUrl = url.replace(pathDataRE, (all, key) => {
          return paths[key]
        })
      }
    }
    config.method = config.method || method
    // config参数中传递url将覆盖外部的url设置
    config.url = config.url || replacedUrl || url

    if (method === 'put' || method === 'post' || method === 'patch') {
      config.data = config.data || data
    } else {
      config.params = config.params || data
    }
    return http.request(config)
  }
}

export const get = (url) => httpAgent('get', url)
export const post = (url) => httpAgent('post', url)
export const put = (url) => httpAgent('put', url)
export const head = (url) => httpAgent('head', url)
export const del = (url) => httpAgent('delete', url)
export const patch = (url) => httpAgent('patch', url)

export default httpAgent
